import { basketNotificationElement, notificationBarTimeout } from "./showBasketNotificationBar";


export function hideBasketNotificationBar() {
  if (!basketNotificationElement) {
    console.warn("Basket notification bar is not supported on current page.");
    return;
  }
  
  basketNotificationElement.classList.remove("active");

  setTimeout(() => {
    basketNotificationElement.innerHTML = ""; 
  }, 200);
  
  if (notificationBarTimeout) {
    clearTimeout(notificationBarTimeout);
  }
}
